import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  const [active, setActive] = useState('all');
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    setActive(slug);
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-8">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-xl md:text-2xl text-foreground-100">影片分类</h2>
      </div>
      <div className="flex flex-wrap gap-2">
        {categories.map((cat) => (
          <button
            key={cat.slug}
            onClick={() => handleClick(cat.slug)}
            className={`px-5 py-2 rounded-full text-sm whitespace-nowrap transition-all duration-300 cursor-pointer ${
              active === cat.slug
                ? 'bg-primary-500 text-background-950 font-medium'
                : 'bg-background-100 text-foreground-400 hover:text-foreground-200 hover:bg-background-200'
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>
    </section>
  );
}